import { render, staticRenderFns } from "./Vereniging.vue?vue&type=template&id=293b1b4a&scoped=true&"
import script from "./Vereniging.vue?vue&type=script&lang=ts&"
export * from "./Vereniging.vue?vue&type=script&lang=ts&"
import style0 from "./Vereniging.vue?vue&type=style&index=0&id=293b1b4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293b1b4a",
  null
  
)

export default component.exports